import { post } from '@/lib/http'

export function getPermission (params = {}) {
  return post('/passport/permission', params)
}
